import React, { useState } from "react";
import { useTranslation } from "react-i18next";
import { Identifiable } from "../../../models/Identifiable";
import getId from "../../../../utils/getId";
import EAAlert from "../../shared/EAAlert";
import LightBox from "../../../../features/LightBox";

interface IProps {
  humanName: string;
  humanPicture: string;
  deputyHumanIds: Identifiable;
  deputyHumanName: string;
}

const CoachInfo: React.FC<IProps> = ({ humanName, humanPicture, deputyHumanIds, deputyHumanName }) => {
  const { t } = useTranslation();
  const [open, setOpen] = useState(false);

  if (humanName && humanName.length > 1) {
    return (
      <>
      <div className="coach ">
        <div onClick={() => setOpen(!open)}
          className={`coach-img ${humanPicture.length <= 1 ? "coach-img-none" : ""}`}
          style={humanPicture.length ? { backgroundImage: `url(${humanPicture})` } : undefined}
        />

        <div className="coach-details">
          {getId(deputyHumanIds) ? (
            <>
              <EAAlert type="warning" message={t("zastepstwo")} compact />
              <b>
                <s>{humanName}</s> {deputyHumanName}
              </b>
            </>
          ) : (
            <b>{humanName}</b>
          )}
          <span>{t("trener_opiekun")}</span>
        </div>
      </div>
      
            {open && (
        <LightBox
          imageUrl={humanPicture}
          open={open}
          closeModal={() => setOpen(false)}
          onAccept={() => {}}
        >
        </LightBox>
      )}
          </>
    );
  }

  return <></>;
};

export default CoachInfo;
